<template>
    <div>
        <h1 class="mt-1 pb-2 mb-1">{{ props.product.title }}</h1>

        <!-- Star review -->
        <div class="flex items-center mt-1">
            <!--UiStarRating :rating="5" :reviews="123" /-->
        </div>

        <!-- custom short description-->
        
        <p class="border-black border-b pb-6">{{ props.product.shortDescription.value }}</p>        

        <!-- Price & stock -->
        <div class="text-lg mt-5border-none md:border-b border-black pt-1">
            <div class="flex items-center gap-5">
                <span class="text-xl" v-if="isCustom">From</span><UiPrice class="large" :amount="props.product.priceRange.minVariantPrice.amount" />
            </div>
        
            <p class="small mt-2 pb-2">
                Shipped within 90 days. 
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
const props = defineProps({
  
  product: {
    type: Object,
    required: true,
  },
  isCustom: {
    type: Boolean,
    default: false
  }
});

const numberOfVariationsAvailableForPurchase = computed(() => {
  return props.product.variants.edges.filter((variant: { node: { availableForSale: boolean } }) => variant.node.availableForSale).length;
});

const hasOptions = computed(() => {
    return props.product.options[0].name !== 'Title';    
});
</script>

<style scoped>
@reference "../../assets/css/main.css";

h1{
  @apply text-3xl mb-4;
  font-variation-settings: 'wght' 410, 'wdth' 100, 'slnt' 0;
}

</style>